export default __webpack_public_path__ + "static/media/sub_header_bg.709cc10d.png";